/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  TradingTransactionTokenAmounts,
  TradingTransactionTokenAmountsFromJSON,
  TradingTransactionTokenAmountsFromJSONTyped,
  TradingTransactionTokenAmountsToJSON,
} from './TradingTransactionTokenAmounts'

/**
 *
 * @export
 * @interface TradingTransaction
 */
export interface TradingTransaction {
  /**
   *
   * @type {number}
   * @memberof TradingTransaction
   */
  timestamp?: number
  /**
   *
   * @type {string}
   * @memberof TradingTransaction
   */
  txHash?: string
  /**
   *
   * @type {number}
   * @memberof TradingTransaction
   */
  txFee?: number
  /**
   *
   * @type {TradingTransactionTokenAmounts}
   * @memberof TradingTransaction
   */
  tokenAmounts?: TradingTransactionTokenAmounts
}

export function TradingTransactionFromJSON(json: any): TradingTransaction {
  return TradingTransactionFromJSONTyped(json, false)
}

export function TradingTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TradingTransaction {
  if (json === undefined || json === null) {
    return json
  }
  return {
    timestamp: !exists(json, 'timestamp') ? undefined : json['timestamp'],
    txHash: !exists(json, 'txHash') ? undefined : json['txHash'],
    txFee: !exists(json, 'txFee') ? undefined : json['txFee'],
    tokenAmounts: !exists(json, 'tokenAmounts')
      ? undefined
      : TradingTransactionTokenAmountsFromJSON(json['tokenAmounts']),
  }
}

export function TradingTransactionToJSON(value?: TradingTransaction | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    timestamp: value.timestamp,
    txHash: value.txHash,
    txFee: value.txFee,
    tokenAmounts: TradingTransactionTokenAmountsToJSON(value.tokenAmounts),
  }
}
